<template>
  <div>
    <div class="banner">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082502475012.jpg"></el-image>
      <div class="cover">
        <h1>发展历程</h1>
        <div class="subtitle">关于诗董</div>
      </div>
    </div>
    <div class="history">
      <el-row :gutter="40">
        <el-col :span="12">
          <div class="nav clearfix">
            <div class="img">
              <el-image :src="xjCategory==null?'/img/b10.png':xjCategory.coverUrl"></el-image>
            </div>
            <div class="title">{{ xjCategory == null ? '橡胶业务发展历程' : xjCategory.name }}</div>
          </div>
          <div class="text-2 clearfix">
            {{ xjCategory == null ? '' : xjCategory.description }}
          </div>
          <div class="custom-timeline-box  clearfix">
            <div class="item" v-for="(item,index) in xjList" :key="index">
              <div class="year-title">
                <div class="year-name">{{ item.name }}</div>
                <div class="year-line"></div>
              </div>
              <div class="desc">
                {{ item.description }}
                <div class="a-img" v-if="item.coverUrl!=null">
                  <el-image :src="item.coverUrl"></el-image>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="nav clearfix">
            <div class="img">
              <el-image :src="stCategory==null?'/img/b10.png':stCategory.coverUrl"></el-image>
            </div>
            <div class="title">{{ stCategory == null ? '橡胶业务发展历程' : stCategory.name }}</div>
          </div>
          <div class="text-2 clearfix">
            {{ stCategory == null ? '' : stCategory.description }}
          </div>
          <div class="custom-timeline-box  clearfix">
            <div class="item" v-for="(item,index) in stList" :key="index">
              <div class="year-title">
                <div class="year-name">{{ item.name }}</div>
                <div class="year-line"></div>
              </div>
              <div class="desc">
                {{ item.description }}
                <div class="a-img" v-if="item.coverUrl!=null">
                  <el-image :src="item.coverUrl"></el-image>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {getCourseInfoIndex} from '@/api/api'

export default {
  name: "Index",
  data() {
    return {
      xjList: null,
      stList: null,
      xjCategory: null,
      stCategory: null
    }
  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      getCourseInfoIndex().then((res) => {
        this.xjList = res.data.xjList;
        this.stList = res.data.stList;
        this.xjCategory = res.data.xjCategory;
        this.stCategory = res.data.stCategory;
      })
    }
  }
}
</script>
<style scoped>
@import url("Index.css?v=100");
</style>